import { DotLoading } from 'antd-mobile'

export default function Loading() {
  return (
    <div style={{ width: '100%', height: '100%' }} className="flex-center">
      <DotLoading />
    </div>
  )
}
